const allArticlesButton = document.querySelector('.all__articles__tag__button');

if (allArticlesButton) {
    allArticlesButton.addEventListener('click', () => {
        document.querySelector('.all__articles__tag').classList.toggle('active');
    });
}